import React, { useState, useEffect } from "react";
import { UserBenefitInput, CompanyBenefitTypeView } from "../../../../models/payroll";
import { DatePicker as CustomDatePicker } from '../../../../components/dateTimePickers';
import { Dialog, DialogContent, DialogHeader, DialogBody, DialogFooter, DialogTitle } from "../../../../components/ui/Dialog";
import Select from "../../../../components/ui/Select";
import Button from "../../../../components/ui/Button";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (input: UserBenefitInput) => void;
  benefit?: UserBenefitInput;
  companyBenefitTypes: CompanyBenefitTypeView[];
  t: any;
};

const UserBenefitForm: React.FC<Props> = ({ open, onClose, onSave, benefit, companyBenefitTypes, t }) => {
  const [benefitTypeId, setBenefitTypeId] = useState<number | undefined>(undefined);
  const [effectiveDate, setEffectiveDate] = useState<Date | null>(null);
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);

  useEffect(() => {
    if (benefit) {
      setBenefitTypeId(benefit.companyBenefitTypeId);
      setEffectiveDate(benefit.effectiveDate ? new Date(benefit.effectiveDate) : null);
      setExpiryDate(benefit.expiryDate ? new Date(benefit.expiryDate) : null);
    }
  }, [benefit]);

  const handleSave = () => {
    const input: UserBenefitInput = {
      id: benefit?.id,
      userId: benefit?.userId,
      companyBenefitTypeId: benefitTypeId,
      effectiveDate: effectiveDate ?? undefined,
      expiryDate: expiryDate ?? undefined,
    };
    onSave(input);
  };

  const benefitOptions = companyBenefitTypes.map(x => ({ label: (x.name || '').toString(), value: x.id }));
  const isEditMode = benefit?.id != undefined && benefit?.id != null && benefit?.id != 0;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{benefit ? t("Edit Benefit") : t("Add Benefit")}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-3">
            <Select
              label={t("Type")}
              options={benefitOptions}
              value={benefitTypeId}
              onChange={(value: any) => setBenefitTypeId(value || null)}
              searchable
              disabled={isEditMode}
            />
            <CustomDatePicker
              label={t("Effective Date")}
              value={effectiveDate}
              onChange={(date: any) => setEffectiveDate(date)}
            />
            <CustomDatePicker
              label={t("Expiry Date")}
              value={expiryDate}
              onChange={(date: any) => setExpiryDate(date)}
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <div className="flex justify-center gap-3 w-full">
            <Button variant="default" onClick={handleSave}>
              {t("Save")}
            </Button>
            <Button variant="outline" onClick={onClose}>
              {t("Cancel")}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserBenefitForm;
